import styled from 'styled-components';

import { SelectPlanStyles } from '../SelectPlan.styles';

export const OFFER_CARD_BG_IMAGE_URL = '/assets/paywall/offer-card/bg.png';

export const OFFER_CARD_HEARTS_IMAGE_URL =
  '/assets/paywall/offer-card/hearts.png';

/** Заголовок над карточкой: REDEEM YOUR UNIQUE ONE-TIME OFFER NOW! */
export const OfferHeadline = styled.div`
  font-family: Poppins, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  letter-spacing: 0%;
  text-align: center;
  text-transform: uppercase;
  color: #fff;
  margin-bottom: 16px;
`;

/** Слово UNIQUE с градиентом */
export const UniqueGradientText = styled.span`
  background: linear-gradient(103.37deg, #7f36f3 9.6%, #ed0d80 90.4%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
`;

export const CardBorderWrapper = styled.div`
  width: 100%;
  height: 354px; /* 350 + 2*2 padding */
  padding: 2px;
  border-radius: 32px;
  background: linear-gradient(297.42deg, #803eff 0%, #ff3636 95.78%);
`;

export const CardInner = styled.div`
  width: 100%;
  height: 350px;
  border-radius: 30px;
  background-color: #00000099;
  background-image: url(${OFFER_CARD_BG_IMAGE_URL}),
    linear-gradient(0deg, #00000099, #00000099);
  background-size: cover;
  background-position: center;
  backdrop-filter: blur(15px);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  flex: 1;
  padding-top: 20px;
`;

export const HeartsImage = styled.img.attrs({
  src: OFFER_CARD_HEARTS_IMAGE_URL,
  alt: '',
})`
  height: 90px;
  width: auto;
  object-fit: contain;
  flex-shrink: 0;
`;

export const CardTitle = styled.div`
  margin-top: 12px;
`;

export const CardDescription = styled.div`
  margin-top: 8px;
  text-align: center;
`;

export const TimerRow = styled.div`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: stretch;
  margin-top: 12px;
`;

export const TimerBlock = styled.div`
  width: 68px; /* 66 + 2 */
  height: 66px; /* 64 + 2 */
  padding: 1px;
  border-radius: 13px;
  background: linear-gradient(180deg, #6f1244 0%, #6330c5 100%);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const TimerBlockInner = styled.div`
  width: 66px;
  height: 64px;
  border-radius: 12px;
  background: #000000;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const TimerValue = styled.span`
  font-family: Poppins, sans-serif;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 0.15em;
  text-align: center;
  color: #fff;
`;

export const TimerLabel = styled.div`
  text-align: center;
`;

export const CardPriceRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 12px;
`;

/** Кнопка GET PREMIUM: градиентная рамка, плавный градиент фона, подсветка текста (как CLAIM OFFER) */
export const GetPremiumButton = styled.button`
  display: block;
  border-radius: 12px;
  border: 2px solid transparent;
  padding: 11px 60px;
  color: #fff;
  margin: 16px auto 16px;
  width: 100%;
  font-family: Poppins, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.1px;
  text-align: center;
  vertical-align: middle;
  cursor: pointer;
  text-shadow: 0 0 4px #ffffff80;
  background: linear-gradient(
      180deg,
      rgba(255, 255, 255, 0.4) 0%,
      rgba(0, 0, 0, 0) 100%
    ),
    linear-gradient(
      0deg,
      var(--button-color-primary, #803eff),
      var(--button-color-primary, #803eff)
    ),
    linear-gradient(180deg, #d3bdff 0%, #5926bc 100%);
  background-clip: padding-box, padding-box, border-box;
  background-origin: padding-box, padding-box, border-box;
`;

export const OfferCardSection = SelectPlanStyles;
